import { Menu } from '@/types/menu';

export function getCurrentMenu(pathname: string): Menu | undefined {
  // HOMEかどうか
  const regex_home = /^\/home($|\/)/;
  if (regex_home.test(pathname)) {
    return 'HOME';
  }

  // NOTEかどうか
  const regex_note = /^\/notes($|\/)/;
  if (regex_note.test(pathname)) {
    return 'NOTE';
  }

  // GOALかどうか
  const regex_goal = /^\/goals($|\/)/;
  if (regex_goal.test(pathname)) {
    return 'GOAL';
  }

  // SUPPORTERかどうか
  const regex_supporter = /^\/supporters($|\/)/;
  const regex_supporter2 = /^\/footballers($|\/)/;
  if (regex_supporter.test(pathname) || regex_supporter2.test(pathname)) {
    return 'SUPPORTER';
  }

  // VIDEOかどうか
  const regex_video = /^\/videos($|\/)/;
  if (regex_video.test(pathname)) {
    return 'VIDEO';
  }

  // NOTIFICATIONかどうか
  const regex_notification = /^\/notifications($|\/)/;
  if (regex_notification.test(pathname)) {
    return 'NOTIFICATION';
  }

  return undefined;
}
